module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/venues-4d8a79ac3832f18c433e28241bb69a5f.webp";